"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_token_group_1 = require("../token/awsui-token-group");
var awsui_select_1 = require("./awsui-select");
var MultiselectWrapper = /** @class */ (function (_super) {
    __extends(MultiselectWrapper, _super);
    function MultiselectWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiselectWrapper.prototype.findTokens = function () {
        return new awsui_token_group_1.default(this.find('awsui-token-group').getElement()).findTokens();
    };
    /**
     * Returns a token.
     *
     * @param tokenIndex 1-based index of the token to return.
     */
    MultiselectWrapper.prototype.findToken = function (tokenIndex) {
        return new awsui_token_group_1.default(this.find('awsui-token-group').getElement()).findToken(tokenIndex);
    };
    /**
     * Returns a token toggle button.
     */
    MultiselectWrapper.prototype.findTokenToggle = function () {
        return this.find('.awsui-multiselect__token-toggle');
    };
    /**
     * Selects an option for the given index by triggering a MouseEvent.
     *
     * When using grouped options, use `selectOptionById` instead.
     *
     * This utility does not open or close the dropdown of the given Multiselect and it will need to be called explicitly in your test.
     *
     * Example:
     * ```
     * wrapper.openDropdown();
     * wrapper.selectOption(0);
     * wrapper.closeDropdown();
     * ```
     *
     * @param index 1-based index of the option to select
     */
    MultiselectWrapper.prototype.selectOption = function (index) {
        return _super.prototype.selectOption.call(this, index);
    };
    /**
     * Selects an option for the given id by triggering a MouseEvent.
     *
     * This utility does not open or close the dropdown of the given Multiselect and it will need to be called explicitly in your test.
     *
     * Example:
     * ```
     * wrapper.openDropdown();
     * wrapper.selectOptionById('0');
     * wrapper.closeDropdown();
     * ```
     *
     * @param id
     */
    MultiselectWrapper.prototype.selectOptionById = function (id) {
        return _super.prototype.selectOptionById.call(this, id);
    };
    __decorate([
        dom_1.usesDom
    ], MultiselectWrapper.prototype, "selectOption", null);
    __decorate([
        dom_1.usesDom
    ], MultiselectWrapper.prototype, "selectOptionById", null);
    return MultiselectWrapper;
}(awsui_select_1.default));
exports.default = MultiselectWrapper;
//# sourceMappingURL=awsui-multiselect.js.map